import React, { useEffect, useState, useCallback } from "react";
import moment from "moment";
import { useTranslation } from 'react-i18next';
import { useStoreState, useStoreActions } from 'easy-peasy';

import { BallTriangle, RotatingTriangles } from 'react-loader-spinner'
import { Row, Col, Container, Card, CardHeader, CardBody } from "stories/layout";
import { Input } from "stories/forms";
import { Typography, Button, Link, IconButton, Modal, Spinner, BreadcrumbsDynamic, Popover } from "stories/components";
import { PageHeader, PageContainer } from "components/Page"
import { TableAuto } from "stories/tables"
import { round, roundScaleDecimals, thousandFormat } from "services/helpers"

import { httpGetPortfolioStocksList, httpGetPortfolioSummary, httpGetPortfolioSummaryExcel } from "services/portfolios"
import { httpGetStockDateBalance } from "services/transactions"
import { httpGetStockData } from "services/stocks"
import { httpGetOpenAiResponse } from "services/openai"
import { parseQuery } from "services/queryParams";
import CurrencySelect from "components/Forms/CurrencySelect/CurrencySelect"
import { useNotification } from "stories/components/Notification"
import { useAppDialog } from "components/AppDialog/useAppDialog"

import { useAppContext } from "contexts/AppContext"

import PortfolioSelectStore from "components/Forms/PortfolioSelect/PortfolioSelectStore"
import PortfolioSelect from "components/Forms/PortfolioSelect/PortfolioSelect"
import SectorSelect from "components/Forms/SectorSelect/SectorSelect"
import InvestmentTypeCateSelect from "components/Forms/InvestmentTypeCateSelect/InvestmentTypeCateSelect"

import { set } from "date-fns";
// import { CardHeader } from "reactstrap";

import "./PortfolioAi.css"

const PortfolioAi = ({match, history, location}) => {
  
  const { t } = useTranslation();
  const { dialog, notify } = useAppDialog();
  const [selected_currency, setSelectedCurrency] = useState()
  const [selectedSector, setSelectedSector] = useState({sector_select: []});
  const [filters, setFilters] = useState({
    limit: 30,
    offset:0,
    date: moment().format("YYYY-MM-DD"),
    ordering: 'name',
    investmentType:[],
    number_of_stocks: 4,
    cash: 5000,
  })
  
  const getCrumbLinks = () => {
    const crumbLinks = [
      {name: t("Etusivu"), url: "/dashboard/"},
      {name: t("portfolios_list_title","Salkut"), url: "/dashboard/portfolios"},

      {name: t("portfolio_ai_breadcrumb","Salkkutekoäly"), url: "/dashboard/portfolios/summary", optional: true},

    ]
    return crumbLinks
  }
  
  const setFieldValue = (name, value) => {
    setFilters(s => ({
      ...s,
      [name]: value
    }))
  }
  
  const handleChange = ({target}) => {
    setFilters({
      ...filters,
      [target.name]: target.value,
    })
  }

  
  
  const [loadingAi, setLoadingAi] = useState(false)
  const [aiResponse, setAiResponse] = useState()
  const [aiResponseStocks, setAiResponseStocks] = useState([])

  useEffect(() => {
    console.log("useEffect interval")

    const randomFloat = (Math.random() * (3.0 - 1.0) + 1.0) * 1000;

    const interval = setInterval(() => {
      console.log("useEffect interval 2 aiResponseStocks", aiResponseStocks)
      let newData = [...aiResponseStocks];
      if (newData.length > 0) {
        console.log("useEffect interval 3")
        let oneUpdated = false;
        newData.map((stock, index) => {
          if (stock.loading && !oneUpdated) {
            console.log("Loading stock data for: ", stock.name)
            // set loading to false and update aiResponseStocks
            newData[index].loading = false;
            setAiResponseStocks(newData);
            oneUpdated = true;
          }
        })
      }
    }, randomFloat); // milliseconds
    
    return () => {
      clearInterval(interval);
    };
  }, [aiResponseStocks]);
  
  const generateAiPortfolio = () => {
    
    let industry_names = "kaikki käytettävissä olevat toimialat";
    if (selectedSector?.sector_select?.length > 0) {
      industry_names = "";
      selectedSector.sector_select.map((sector) => {
        industry_names = industry_names + ", " + sector?.name;
      })
    }
    const prompt = `Minulla on ${filters.cash}€ rahaa ja haluaisin sijoittaa ne nyt. Mitä Helsingin pörssin arvopapereita suosittelet sijoitussalkkuun, johon halutaan ${filters?.number_of_stocks} eri arvopaperia ja arvopaperit ovat toimialoilta ${industry_names}. Jaa sijoittava summa valittujen arvopaperiden kesken eri tavalalla ja kerro miksi juuri tämä arvopaperi on valittu ja miten raha on painotettu. Anna vastaus arvopaperit listana: [{"name": "arvopaperi1", "money_invested": 1000, "why":"selitys miksi arvopaperi on hyvä valinta salkkuun"},{"name": "arvopaperi2", "money_invested": 9000, "why":"selitys miksi arvopaperi on hyvä valinta salkkuun"}]`;
    const data = {
      prompt: prompt,
      temperature: 0.7,

      engine: "gpt-3.5-turbo",
      max_tokens: 4000,
    };
    setLoadingAi(true);
    httpGetOpenAiResponse(data)
      .then((res) => {
        const result = res?.data?.result;
        setAiResponse(result);

        // Extracting the array portion from the text
        const arrayStartIndex = result.indexOf('[');
        const arrayEndIndex = result.indexOf(']');
        const arrayText = result.substring(arrayStartIndex, arrayEndIndex + 1);
        // Parse the extracted array into a JavaScript array
        const stocksList = JSON.parse(arrayText);
        // const stocksList = JSON.parse(result);
        let stocksListObjects = [];
        stocksList.map((stockObj) => {
          stocksListObjects.push({
              ...stockObj,
              loading: true,
            });
        })
        let stocksListObjectsOrdered = stocksListObjects.sort((a, b) => (a.money_invested < b.money_invested ? 1 : -1))
        setAiResponseStocks(stocksListObjectsOrdered);

        
        // setAiResponseStocks(JSON.parse(arrayText));
        // const companyList = JSON.parse(arrayText);
        

      })
      .catch((e) => {
        notify(e?.message || String(e));
      })
      .finally(() => {
        setLoadingAi(false);
    });
  };
  
  // Sector BEGIN
  
  const handleSectorChange = (name, value) => {
    setSelectedSector(s => ({
      ...s,
      [name]: value
    }))
  }
  
  const getSectorSelect = useCallback(() => {
    return (
      <SectorSelect
        className="sk_portfolio_ai_sector_select text-dark"
        name="sector_select"
        label={`${t("PrivateInvestmentFundEdit_sector", "Toimialat")}` }
        multiple={true}
        onChange={handleSectorChange}
        value={selectedSector?.sector_select}
        setFieldValue={handleSectorChange}
      />
    )
  }, [selectedSector])
  
  // Sector END
  
  return (
    <>
    {dialog}
    <Row className="d-flex flex-wrap">
      <Col>
       <PageHeader title={t("it_portfolio_ai_title", "Salkkutekoäly")} />
        <BreadcrumbsDynamic links={getCrumbLinks()} />
      </Col>
      <Col md="6" xs="12" className="d-flex flex-column justify-content-end  mr-xs-auto align-self-end mb-3 " style={{minWidth: "50px"}}>

      </Col>
    </Row>

      <PageContainer bgColor="bg-dark" className="text-white"> 
        <div className="d-flex justify-content-start mb-2 d-flex flex-wrap">

          <div className="p-2">
            Pörssi: Helsinki
          </div>
          <div className="p-2">
            Sijoitettava summa: <Input type="number" name="cash" value={filters?.cash} onChange={handleChange} />
          </div>
          <div className="p-2">
            Arvopaperien määrä: <Input type="number" name="number_of_stocks" value={filters?.number_of_stocks} onChange={handleChange} />
          </div>

          {/*
          <div className="p-2">
            Jakaa osinkoja: Kyllä/ei
          </div>
          */}

          <div className="p-2">
            {getSectorSelect()}
          </div>

          
        </div>

        <div className="mb-3">
          <Button name="profit_search_button" className="mt-2" color="secondary" onClick={() => generateAiPortfolio()}>{t("Muodosta salkku")}</Button>
        </div>

        <div>
          {loadingAi && <BallTriangle
            height={128}
            width={128}
            radius={5}
            color="#4fa94d"
            ariaLabel="ball-triangle-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            />}
        </div>
        
        { loadingAi === false && aiResponseStocks.length > 0 ? (
        
          <div className="row">
            {aiResponseStocks.map((stock, index) => (
              <div className="col-sm-3" key={index}>
                <Card className="zoomIn text-dark">
                {stock.loading ? (
                  <>
                  <RotatingTriangles
                    visible={true}
                    height="80"
                    width="80"
                    color="#4fa94d"
                    ariaLabel="rotating-triangles-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                  />

                    {/*
                    <BallTriangle height={128} width={128} radius={3} color="#4fa94d" ariaLabel="ball-triangle-loading" wrapperStyle={{}} wrapperClass="" visible={true} />
                    */}
                  </>
                  
                ) : (
                  <>
                  <CardHeader className="text-dark">{stock.name}</CardHeader>
                  <CardBody className="text-dark">Sijoitus: {stock.money_invested}€ ({round(stock?.money_invested/filters?.cash, 2) * 100.0}&#37; painotus)</CardBody>
                  <CardBody className="text-dark">{stock.why}</CardBody>
                  </>
                )}
                </Card>
              </div>
            ))}
          </div>
        ) : null }

        <div>
          {/* JSON.stringify(aiResponseStocks) */}
        </div>
        
        <div>
        {/* aiResponse */}
        </div>
        
        <div>
          <b>Huom! Salkkutekoäly antaa vain ehdotuksia. Sijoittaja itse on vastuussa tekemistään valinnoista ja sijoituksista.</b>
        </div>


        
      </PageContainer>
      

    </>
  );
}

export default PortfolioAi;
